<template>
  <out-layout>
    <header slot="form-header" class="header">
      <h3 class="title">O prazo para ativação da conta expirou</h3>
    </header>

    <div slot="form-content" class="message">
      <v-card-text class="token">
        <img class="icon" src="/src/assets/image/icon/security.svg" alt="Ícone de Segurança">
        <span class="text">
          Clique no botão abaixo e enviaremos no e-mail <strong>bob@rogalabs.com</strong>
          as instruções para autenticação de segurança da sua conta.
        </span>
      </v-card-text>

      <v-card-actions class="action">
        <v-btn color="primary">
          <v-icon left>mdi-refresh</v-icon>
          <span class="text">Reenviar</span>
        </v-btn>
      </v-card-actions>
    </div>

    <template slot="navigation">
      <v-btn flat small color="primary" class="link" :to="'/conta/entrar'">
        <v-icon left>mdi-account-circle</v-icon>
        <span class="text">Voltar ao login</span>
      </v-btn>
    </template>
  </out-layout>
</template>

<script>
import OutLayout from '@/layouts/OutLayout';

export default {
  name: 'ExpiredSignup',
  components: {
    OutLayout,
  },
};
</script>

<style scoped lang="scss">
.message {
  > .token {
    & {
      padding: 0;
      margin-top: 2rem;
      margin-bottom: 2rem;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
    }
    > .icon {
      margin-right: 2rem;
      width: 60px;
    }
  }
}

.navigation {
  > .link {
    text-transform: none;
  }
}
</style>
